module.exports = __webpack_public_path__ + "media/images/levelup_crown_blue-97beb8a4f27f295d4395ef3e8b1ce52f.png";